import { Observable, BehaviorSubject, Subject, combineLatest as observableCombineLatest } from "rxjs";
import { map, skip, mergeMap, share, distinctUntilChanged, tap } from "rxjs/operators";
import { GeoFrame } from "../geoframe/geoframe";
import { EdgeDirection } from "../graph/edge/EdgeDirection";
export class RenderService {
    constructor(scene, navigator, element) {
        this._scene = scene;
        this._navigator = navigator;
        this._currentNode$ = navigator.stateService.currentNode$;
        this._element = element;
        this._size$ = new BehaviorSubject({
            height: this._element.offsetHeight,
            width: this._element.offsetWidth,
        });
        let currentspeed = 0.62;
        this._navigator.playService.speed$.subscribe((speed) => {
            if (speed > 0)
                currentspeed = speed;
        });
        const _buffering$ = observableCombineLatest([
            this._scene.userinputapi.buffering$.pipe(distinctUntilChanged()),
            this._scene.userinputapi.tileloading$,
        ]).pipe(map(([buffering, tileloading]) => {
            if (buffering || tileloading)
                return true;
            return false;
        }));
        _buffering$.subscribe((loading) => {
            if (loading) {
                this._navigator.playService.setSpeed(0.0);
                this._navigator.stateService.setSpeed(0.0);
            }
            else {
                this._navigator.playService.setSpeed(currentspeed);
                if (this._navigator.playService.playing) {
                    this._scene.getCurrentGeoFrameCollection().play();
                }
            }
        });
        this._currentNode$
            .pipe(mergeMap((currentNode) => {
            if (!currentNode.full)
                return;
            return observableCombineLatest([
                this._navigator.graphService.cacheSequenceNodes$(currentNode.sequenceKey),
                this._navigator.graphService.graph$,
            ]).pipe(map(([sequence, graph]) => {
                const geoFrame = new GeoFrame(this._scene, currentNode.frame);
                const geoFrames = [];
                for (const key of sequence.keys) {
                    try {
                        const g = new GeoFrame(this._scene, graph.getNode(key).frame);
                        geoFrames.push(g);
                    }
                    catch {
                        console.warn(`could not convert ${key} node to geoframe`);
                    }
                }
                if (!this._navigator.playService.playing) {
                    this._scene.setGeoFrames(geoFrame, geoFrames, 1);
                }
                else {
                    const stepsize = currentspeed > 0.7 && currentspeed <= 0.9 ? 2 : currentspeed > 0.9 ? 3 : 1;
                    const framenumber = geoFrames.findIndex((e) => e.key == geoFrame.key);
                    if (framenumber % stepsize == 0) {
                        this._scene.setGeoFrames(geoFrame, geoFrames, stepsize);
                    }
                }
                return currentNode;
            }));
        }), distinctUntilChanged((node_prev, node) => {
            if (!node_prev.full)
                return true;
            return node.frame.segment === node_prev.frame.segment;
        }), tap((x) => {
            if (!this._navigator.playService.playing) {
                const currentplaymode = x.frame.playmode == "forward" ? EdgeDirection.Next : EdgeDirection.Prev;
                this._navigator.playService.setDirection(currentplaymode);
            }
        }))
            .subscribe();
        this._renderCamera$ = new Observable((observer) => {
            this._scene.infrascene.onCameraMoved = (camera) => {
                observer.next(camera);
            };
        }).pipe(share());
        this._resize$ = new Subject();
        this._resize$
            .pipe(map(() => {
            return { height: this._element.offsetHeight, width: this._element.offsetWidth };
        }))
            .subscribe(this._size$);
        //Set Playmode on Geoframecollections
        observableCombineLatest([
            this._navigator.playService.playing$.pipe(skip(1)),
            this._scene.userinputapi.geoframecollectionchanged$,
        ]).subscribe(([playing, geoframecollection]) => {
            if (playing) {
                geoframecollection.play();
            }
            else {
                geoframecollection.stop();
            }
        });
    }
    // FIXME: This needs to be wired up to scene.
    get size$() {
        return this._size$;
    }
    get resize$() {
        return this._resize$;
    }
    get renderCamera$() {
        return this._renderCamera$;
    }
}
//# sourceMappingURL=RenderService.js.map